<template>
	<vue-final-modal
		v-model="isVisible"
		:class="mergedClass"
		:overlay-class="mergedOverlayClass"
		:content-class="mergedContentClass"
		content-transition="vfm-fade"
		overlay-transition="vfm-fade"
		:click-to-close="closable && clickToClose"
		:esc-to-close="closable && escToClose"
		@update:model-value="handleModelValueChange()"
	>
		<div class="modal-content">
			<div class="modal-body text-center">
				<h5 :class="['mb-' + ($slots.default ? '2' : '0')]" v-if="title">{{ title }}</h5>
				<p class="mb-0">
					<slot />
				</p>
			</div>
			<div class="modal-footer flex-nowrap p-0">
				<button
					type="button"
					class="btn btn-lg fs-6 text-decoration-none col py-3 m-0 rounded-0 border-end"
					:class="['btn-' + confirmColor]"
					@click="handleConfirm"
				>
					<strong>{{ confirmText }}</strong>
				</button>
				<button
					type="button"
					class="btn btn-lg btn-link fs-6 text-decoration-none col py-3 m-0 rounded-0"
					@click="handleClose"
				>{{ cancelText }}</button>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss"></style>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
	name: "BootstrapConfirmModal",
	props: {
		modelValue: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: "Заголовок",
		},
		confirmText: {
			type: String,
			default: "Подтвердить",
		},
		confirmColor: {
			type: String,
			default: "primary",
		},
		cancelText: {
			type: String,
			default: "Отмена",
		},
		size: {
			type: String,
			default: "",
		},
		centered: {
			type: Boolean,
			default: false,
		},
		scrollable: {
			type: Boolean,
			default: false,
		},
		fullscreen: {
			type: Boolean,
			default: false,
		},
		closable: {
			type: Boolean,
			default: true,
		},
		class: {
			type: [String, Array, Object],
			default: () => [],
		},
		overlayClass: {
			type: [String, Array, Object],
			default: () => [],
		},
		contentClass: {
			type: [String, Array, Object],
			default: () => [],
		},
		clickToClose: {
			type: Boolean,
			default: true,
		},
		escToClose: {
			type: Boolean,
			default: true,
		},
		onConfirm: {
			type: Function,
			default: null,
		},
		onClose: {
			type: Function,
			default: null,
		},
	},
	computed: {
		isVisible: {
			get() {
				return this.modelValue;
			},
			set(val) {
				this.$emit("update:modelValue", val);
			},
		},
		mergedClass() {
			const baseClasses = ["modal", "d-block"];
			if (typeof this.class === "string") {
				return [...baseClasses, ...this.class.trim().split(/\s+/)];
			}
			if (Array.isArray(this.class)) {
				return [...baseClasses, ...this.class];
			}
			if (typeof this.class === "object" && this.class !== null) {
				return [...baseClasses, this.class];
			}
			return baseClasses;
		},
		mergedOverlayClass() {
			const baseClasses = ["modal-backdrop"];
			if (typeof this.overlayClass === "string") {
				return [
					...baseClasses,
					...this.overlayClass.trim().split(/\s+/),
				];
			}
			if (Array.isArray(this.overlayClass)) {
				return [...baseClasses, ...this.overlayClass];
			}
			if (
				typeof this.overlayClass === "object" &&
				this.overlayClass !== null
			) {
				return [...baseClasses, this.overlayClass];
			}
			return baseClasses;
		},
		mergedContentClass() {
			const baseClasses = [
				"modal-dialog",
				{
					"modal-dialog-centered": this.centered,
					"modal-dialog-scrollable": this.scrollable,
					[`modal-${this.size}`]: !!this.size,
					"modal-fullscreen": this.fullscreen,
				},
			];
			if (typeof this.contentClass === "string") {
				return [
					...baseClasses,
					...this.contentClass.trim().split(/\s+/),
				];
			}
			if (Array.isArray(this.contentClass)) {
				return [...baseClasses, ...this.contentClass];
			}
			if (
				typeof this.contentClass === "object" &&
				this.contentClass !== null
			) {
				return [...baseClasses, this.contentClass];
			}
			return baseClasses;
		},
	},
	methods: {
		handleConfirm() {
			this.onConfirm?.();
			this.closeModal();
		},
		handleClose() {
			this.onClose?.();
			this.closeModal();
		},
		handleModelValueChange(val) {
			if (!val) {
				this.handleClose();
			}
		},
		closeModal() {
			this.$emit("update:modelValue", false);
		},
	},
	components: {
		VueFinalModal,
	},
};
</script>
